var link_viewer_default = {
  "fontElementMap": "DjnXB",
  "link": "z-7lY",
  "linkInEditor": "UST-B",
  "linkInViewer": "mGbcK",
  "toolbarUrlContainer": "t5r9R",
  "toolbarUrl": "_41eVR",
  "toolbarUrlAnchor": "ToH7B"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
